import { useQuery } from '@tanstack/react-query'

import { useBackendClient } from '../contexts/BackendClientContext'
import { PositionsGetGlobalInfoResponseType } from '../../backend/types'

const CACHE_KEY = 'position-global-info'

export const useGlobalPositionsInfo = (address?: string) => {
  const backendClient = useBackendClient()

  const results = useQuery({
    queryKey: [CACHE_KEY, address ? address : 'global'],
    queryFn: async () => {
      const positionsGlobalInfo = (await backendClient.positionsGetGlobalInfo({
        walletAddress: address,
      })) as PositionsGetGlobalInfoResponseType

      return positionsGlobalInfo
    },
    refetchInterval: 1000 * 30,
    staleTime: 1000 * 30,
  })

  return {
    isLoading: results.isLoading,
    data: results.data,
  }
}
